import { memo as Memo, useState, useRef, useCallback } from 'react'
import gsap from 'gsap'

//* HOCs
import withLanguageContext from 'context/consumerHOC/LanguageConsumer'
import withUIContext from 'context/consumerHOC/UIConsumer'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import ShareLink from 'components/common/ShareLink'
import Editor from 'components/common/Editor'
import Image from 'components/common/Image'
import Video from 'components/common/Video'
import Icon from 'components/common/Icon'

//* Style
import PostContentStyle from './style'

const PostContent = Memo(({ date, readTime, description, translate, type, winWidth }) => {
	//! State
	const [play, setPlay] = useState(true)

	//! Refs
	const cursorRef = useRef()
	const videoContRef = useRef()

	//! Handle click
	const handleClick = useCallback(() => {
		if (play) {
			setPlay(false)
		} else {
			setPlay(true)
		}
	}, [play])

	//! Handle mouse move
	const handleMouseMove = useCallback((e) => {
		const videoContRect = videoContRef.current.getBoundingClientRect()
		const x = e.clientX - videoContRect.left
		const y = e.clientY - videoContRect.top

		gsap.to(cursorRef.current, { duration: 0.3, opacity: 1, left: x, top: y, scale: 1 })
	}, [])

	//! Handle mouse leave
	const handleMouseLeave = useCallback(() => {
		gsap.to(cursorRef.current, { duration: 0.3, opacity: 0, scale: 0 })
	}, [])

	return (
		<PostContentStyle>
			<Container row>
				<div className={`col-3 col-t-2 col-ts-12`}>
					{type === 'news' && (
						<Text
							tag={`p`}
							className={`p p3 notoSans-medium primary-color9`}
						>
							{readTime}&nbsp;{translate('minRead')}&nbsp;|&nbsp;{date}
						</Text>
					)}
				</div>

				<div className={`content-wrapper ${type === 'event' ? 'event' : ''} col-6 col-t-8 col-ts-12`}>
					{description &&
						description.length > 0 &&
						description.map((item, index) => {
							return item.type === 'editor' ? (
								<Editor
									key={index}
									data={item.text}
								/>
							) : item.file?.type === 'image' ? (
								<Image
									key={index}
									src={item.file?.src}
									alt={item.file?.alt}
								/>
							) : (
								<div
									key={index}
									ref={videoContRef}
									className={`video-wrapper`}
									onMouseMove={handleMouseMove}
									onMouseLeave={handleMouseLeave}
								>
									<Video
										loop={true}
										controls={false}
										autoplay={false}
										src={item.file?.src}
										handleClick={handleClick}
									/>

									<div
										ref={cursorRef}
										className={`play-and-pause-cursor-wrap`}
									>
										<Icon
											name={`${play ? 'play' : 'pause'}`}
											className={`play-and-pause-cursor`}
										/>
									</div>
								</div>
							)
						})}
				</div>

				{(type === 'event' || (winWidth >= 1024 && type === 'news')) && (
					<div className={`share-links-container col-3 col-t-2 col-ts-12`}>
						<div>
							<ShareLink />
						</div>
					</div>
				)}
			</Container>
		</PostContentStyle>
	)
})

export default withUIContext(withLanguageContext(PostContent, ['translate']), ['winWidth'])
